import React from 'react';
import PropTypes from 'prop-types';

function AppTableEmpty(props) {
  const { children, className, colSpan } = props;

  return (
    <tr>
      <td colSpan={colSpan} className={className}>
        {children}
      </td>
    </tr>
  );
}

AppTableEmpty.propTypes = {
  className: PropTypes.string,

  children: PropTypes.node,

  colSpan: PropTypes.number,
};

AppTableEmpty.defaultProps = {
  className: '',
  colSpan: 10,

  children: {},
};

export default AppTableEmpty;
